module.exports = __webpack_public_path__ + "static/media/Icon-arrow-gray-down.ccdca96c.png";